module.exports = __webpack_public_path__ + "resources/img/img_datahunt7_m_en.5171a3c5a3d5fbd3fb355c477d37d8e3.png";